package com.evoapps.evoshift.util

import androidx.compose.material3.CalendarLocale

/**
 * SH-166: the locale of the Material date pickers for the app's [language] ("pl", "uk", "en"):
 * month and weekday names, the headline's date format and, where the platform reads it from the
 * locale (Android, desktop), the first day of the week (Monday in Polish and Ukrainian). Polish and
 * Ukrainian are tied to their countries; English keeps the device's English locale, or British
 * English (Monday first) on a device in another language.
 *
 * On iOS and the web the picker's first day of the week follows the device's region (the iOS
 * calendar, the browser's locale): the Material library does not take it from this locale there.
 */
expect fun pickerCalendarLocale(language: String): CalendarLocale

/** The BCP 47 tag behind [pickerCalendarLocale]; [deviceTag] is the device's own locale. */
fun pickerLocaleTag(language: String, deviceTag: String): String = when (language) {
    "pl" -> "pl-PL"
    "uk" -> "uk-UA"
    else -> if (deviceTag.substringBefore('-').substringBefore('_') == "en") deviceTag.replace('_', '-') else "en-GB"
}
